import type { Character } from "@/shared/types/character"

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

type CharacterCreatorFields = Pick<
  Character,
  "createdBy" | "creatorUsername" | "creatorDisplayName"
>

function normalizeHandle(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return trimmed
  return trimmed.startsWith("@") ? trimmed : `@${trimmed}`
}

export function getCharacterCreatorLabel(
  character: CharacterCreatorFields
): string | null {
  if (character.creatorUsername?.trim()) {
    return normalizeHandle(character.creatorUsername)
  }

  if (character.creatorDisplayName?.trim()) {
    return character.creatorDisplayName.trim()
  }

  const rawCreator = character.createdBy?.trim()
  if (rawCreator && !UUID_RE.test(rawCreator)) {
    return normalizeHandle(rawCreator)
  }

  return null
}
